import deleteByKey from './deleteByKey';

function deleteLinks(data) {
  return deleteByKey(data, ['_links']);
}

export default deleteLinks;
